/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ProductDto } from './product-dto';

/**
 * 
 * @export
 * @interface DrugHistoryDto
 */
export interface DrugHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof DrugHistoryDto
     */
    'effect'?: DrugHistoryDtoEffectEnum;
    /**
     * 
     * @type {string}
     * @memberof DrugHistoryDto
     */
    'fromDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof DrugHistoryDto
     */
    'id'?: number;
    /**
     * 
     * @type {ProductDto}
     * @memberof DrugHistoryDto
     */
    'product'?: ProductDto;
    /**
     * 
     * @type {string}
     * @memberof DrugHistoryDto
     */
    'time'?: DrugHistoryDtoTimeEnum;
    /**
     * 
     * @type {string}
     * @memberof DrugHistoryDto
     */
    'toDate'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DrugHistoryDtoEffectEnum {
    Remission = 'REMISSION',
    BigImprovement = 'BIG_IMPROVEMENT',
    LittleImprovement = 'LITTLE_IMPROVEMENT',
    NoChange = 'NO_CHANGE',
    LittleDeterioration = 'LITTLE_DETERIORATION',
    BigDeterioration = 'BIG_DETERIORATION',
    ExtremeDeterioration = 'EXTREME_DETERIORATION'
}
/**
    * @export
    * @enum {string}
    */
export enum DrugHistoryDtoTimeEnum {
    Past = 'PAST',
    Currently = 'CURRENTLY'
}


